module.exports = __webpack_public_path__ + "static/corp-rejuvenation-48f9fe3c6532cd933182e2d1d9d0eace.jpg";